import React, { useContext, useEffect, useRef, useState } from "react";
import { RulesContext } from "./RulesContext";
import RuleHeader from "./Components/RuleHeader";
import RuleCategorySelector from "./Components/RuleCategorySelector";
import RuleBody from "./Components/RuleBuilder/RuleBody";
import Button from "Components/DesignSystem/Button/Button";
import { CBA_RULE, CBI_RULE, CBM_RULE } from "./misc/RuleObjectTypes";
import ServiceWrapper from "../../../Services/ServiceWrapper";
import AppSettings from "../../../Settings/AppSettings";
import AuthManager from "../../../Common/AuthManager";
import CBMCategorySelector from "./Components/CBMCategorySelector";
import MatrixComponent from "./Components/CBM_rule_BUilder/Matrix/MatrixComponent";
import { useNavigate } from "react-router";
import Spinner from "Components/DesignSystem/Spinner/Spinner";
import { AppContext } from "Context/AppContext";
import { toast } from "Components/DesignSystem/Toast/useToast";
import { parseJson } from "Common/HelperClass";
import { CBM } from "Pages/GMS/ISR/ISRConstants";


function RulesAddEditManage({ ruleId, type, fromCategoryRelevancy = false, initialCategoryA, initialCategoryB, onClose, onSaved }) {
  const navigate = useNavigate();
  const {
    ruleType,
    setRuleType,
    selectedCategories,
    setSelectedCategories,
    attributesList,
    Loading,
    setLoading,
    ruleDispatch,
    CBMOptions,
    setCBMOptions,
    loadMasterdata,
    setCellStates,
    setCompatibilityData,
    setCbmRuleId,
    setInitialRuleDetails,
  } = useContext(RulesContext);
  const {
    leftCatListOption,
    rightCatListOption,
    leftCatAttributeSet,
    rightCatAttributeSet,
    rightValuesAttr,
    leftValuesAttr,
  } = CBMOptions;
  const api_base_url = AppSettings.GMS_BACKEND_API_URL;
  const [editPage, setEditPage] = useState(false);
  const [ruleDetails, setRuleDetails] = useState(null);
  const [ruleHeaderDetails, setRuleHeaderDetails] = useState({ name: "", rule_type: null, rule_status: 0, description: "", asymmetric: false });
  let appContext = useContext(AppContext);
  let industryId =
    appContext &&
    appContext?.get_selected_industry() &&
    appContext?.get_selected_industry()?.id;
  let channelKey = appContext?.channelKey;
  // AB#15857: on a full page load the selected industry is briefly null, and the rule used to be
  // requested as `rule/list?industry_id=null`. Load it once the industry is known, and once per
  // rule and mode, as before: a later industry change does not reload it.
  const loadedRuleKey = useRef(null);
  useEffect(() => {
    setCbmRuleId(ruleId);
    if (!industryId) return;
    const ruleKey = `${ruleId}|${type}`;
    if (loadedRuleKey.current === ruleKey) return;
    loadedRuleKey.current = ruleKey;
    if (ruleId.includes("_duplicate")) {
      setEditPage(false);
      load_Rule_Details(ruleId.replace("_duplicate", ""), true);
    } else if (ruleId && ruleId !== "0" && type === "copy") {
      setEditPage(false);
      load_Rule_Details(ruleId);
    } else if (ruleId && ruleId !== "0") {
      setEditPage(true);
      if (fromCategoryRelevancy) {
        setTimeout(() => load_Rule_Details(ruleId), 1500);
      } else {
        load_Rule_Details(ruleId);
      }
    } else {
      setEditPage(false);
    }
  }, [ruleId, type, industryId]);

  useEffect(() => {
    if (fromCategoryRelevancy && initialCategoryA && initialCategoryB && ruleId === '0') {
      setSelectedCategories({
        leftCategory: { id: initialCategoryA.id, name: initialCategoryA.name },
        rightCategory: { id: initialCategoryB.id, name: initialCategoryB.name },
      });
      setRuleHeaderDetails(prev => ({
        ...prev,
        name: `${initialCategoryA.name} X ${initialCategoryB.name}`,
        rule_type: CBA_RULE,
      }));
      setRuleType(CBA_RULE);
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const getCellStateFromRuleBody = (rule_body) => {
    return rule_body?.rule?.rule?.reduce((acc, item) => {
      const key =
        rule_body?.leftCatCompatibilityType === "values"
          ? `${item.leftValueId}-${item.rightValueId}`
          : `${item.leftProdId}-${item.rightProdId}`;
      const numericValue = convertToNumeric(item.compatibility);
      acc[key] = numericValue;
      return acc;
    }, {});
  }

  const load_Rule_Details = async (ruleId, duplicatePage = false) => {
    try {
      setLoading({ status: "Loading", message: "Loading Rules details" });
      let ret = await ServiceWrapper.doGet(
        `${api_base_url}rule/list?page=1&per_page=1&industry_id=${industryId}&channel_key=${channelKey}&ruleid=${ruleId}`,
        null,
        null,
        AuthManager.getGmsToken()
      );
      if (!ret.errorfound) {
        if (ret?.data?.data?.length === 0) {
          if (!fromCategoryRelevancy) {
            toast.info("Rule not found");
            navigate("/gms/compatibilities");
          }
          return;
        }
        let ruleDet = ret.data.data[0];

        if (type === "edit" && !duplicatePage) {
          const hasUpdatePermission = appContext?.pm?.checkPermission("gmsrules_update");
          const userobj = AuthManager.getAuthUser();
          const currentUserId = userobj?.profile?.id;
          const isOwner = currentUserId && currentUserId === ruleDet.created_by_userid;

          if (!hasUpdatePermission || !isOwner) {
            toast.warning(
              !isOwner
                ? "You can only edit rules that you have created."
                : "You do not have permission to edit rules."
            );
            navigate(`/gms/rule/view/${ruleId}`, { replace: true });
            return;
          }
        }
        let rule_body = parseJson(ruleDet?.rule_body);

        ruleDet = { ...ruleDet, rule_body };
        if (ruleDet.rule_type === CBM
          && Object.keys(rule_body?.cellStates).length === 0
          && rule_body?.cellStates?.constructor === Object) {
          const convertedData = getCellStateFromRuleBody(rule_body)
          if (convertedData) {
            ruleDet.rule_body.cellStates = convertedData
          }
        }
        if (duplicatePage) {
          const name = ruleDet.name + " [Duplicate]";
          const description = ruleDet.description + " [Duplicate]";
          ruleDet = {
            ...ruleDet,
            name: name,
            description: description,
            commit: false,
            rule_status: 0,
          };
        }
        setRuleDetails(ruleDet);
        setInitialRuleDetails(JSON.parse(JSON.stringify(ruleDet)));
        updateRuleBody(ruleDet);
        setLoading({ status: "Success", message: undefined });
        if (!duplicatePage && type === "edit") {
          setEditPage(true);
        }
      } else {
        setLoading({ status: "Error", message: "Error while Loading Rules" });
      }
    } catch (error) {
      console.error("load_Rule_Details ~ error:", error);
    }
  };

  const updateRuleBody = (ruleBody) => {
    if (ruleBody && ruleBody.rule_type === CBM_RULE) {
      const {
        left_category,
        right_category,
        left_category_name,
        right_category_name,
        rule_body,
      } = ruleBody;
      const {
        compatibilityLevel,
        leftCatCompatibilityType,
        rightCatCompatibilityType,
        defaultCompatibilityValue,
        leftAttributeId,
        rightAttributeId,
        leftValuesAttrName,
        rightValuesAttrName,
        leftAttributeValueId,
        leftAttributeValueName,
        rightAttributeValueId,
        rightAttributeValueName,
        isProductFilter,
        cellStates,
      } = ruleBody.rule_body;

      setSelectedCategories({
        leftCategory: { id: left_category, name: left_category_name },
        rightCategory: { id: right_category, name: right_category_name },
      });
      setCBMOptions((prev) => {
        return {
          ...prev,
          leftCatListOption: leftCatCompatibilityType,
          rightCatListOption: rightCatCompatibilityType,
          leftValuesAttr: leftAttributeId,
          rightValuesAttr: rightAttributeId,
          defaultCompatibilityValue: defaultCompatibilityValue,
          compatibilityLevel: compatibilityLevel,
          leftCatID: left_category,
          rightCatID: right_category,
          leftValuesAttrName,
          rightValuesAttrName,
          leftAttributeValueId,
          leftAttributeValueName,
          rightAttributeValueId,
          rightAttributeValueName,
          isProductFilter,
        };
      });
      const convertedData = getCellStateFromRuleBody(rule_body)
      if (convertedData) {
        setCellStates(convertedData);
      }

      setCompatibilityData(rule_body?.rule?.rule ?? []);
      ruleDispatch({ type: "CBM_RULE_TYPE", data: rule_body.rule.rule });
    } else {
      const {
        left_category,
        right_category,
        left_category_name,
        right_category_name,
      } = ruleBody;
      setSelectedCategories({
        leftCategory: { id: left_category, name: left_category_name },
        rightCategory: { id: right_category, name: right_category_name },
      });
    }
  };

  const convertToNumeric = (compatibility) => {
    switch (compatibility) {
      case "good":
        return 1;
      case "better":
        return 2;
      case "best":
        return 3;
      default:
        return 0;
    }
  };

  const isViewMode = type === "view";

  const ruleHeaderEl = (
    <RuleHeader
      ruleDetails={ruleDetails}
      editPage={editPage}
      load_Rule_Details={load_Rule_Details}
      loading={Loading}
      type={type}
      setRuleDetails={setRuleDetails}
      ruleHeaderDetails={ruleHeaderDetails}
      setRuleHeaderDetails={setRuleHeaderDetails}
      fromCategoryRelevancy={fromCategoryRelevancy}
      onClose={onClose}
      onSaved={onSaved}
    />
  );

  const formContent = (
    <div
      style={
        isViewMode
          ? { pointerEvents: "none", opacity: 0.6, userSelect: "none" }
          : {}
      }
    >
      {((editPage && !ruleDetails) || !loadMasterdata) && (
        <div className="tw-flex tw-justify-center tw-py-10">
          <Spinner size="lg" label="Loading compatibility" showLabel data-testid="rule-form-loading" />
        </div>
      )}
      {((ruleDetails && editPage) || !editPage) && loadMasterdata && (
        <>
          {(ruleType === CBI_RULE || ruleType === CBA_RULE) && (
            <RuleCategorySelector
              ruleBody={ruleDetails && ruleDetails.body}
              ruleDetails={ruleDetails}
              setRuleDetails={setRuleDetails}
              ruleHeaderDetails={ruleHeaderDetails}
              setRuleHeaderDetails={setRuleHeaderDetails}
              type={type}
            />
          )}
          {ruleType === CBM_RULE && (
            <CBMCategorySelector
              ruleBody={ruleDetails && ruleDetails.body}
              ruleId={ruleId}
              load_Rule_Details={load_Rule_Details}
              type={type}
              commit={ruleDetails?.commit}
            />
          )}
          <div className="tw-space-y-5">
            {(ruleType === CBI_RULE || ruleType === CBA_RULE) &&
              attributesList.leftAttributes !== null &&
              attributesList.rightAttributes !== null && (
                <>
                  <RuleBody
                    ruleBody={ruleDetails && ruleDetails?.rule_body?.rule}
                  />
                  <div className="">
                    {/* DS Button (okf/rules § 4.5) — supersedes the § 4.3
                        utility-patched `.outline-button`. `secondary` is the DS
                        outlined action: accent label, resting border on `edge`
                        (§ 33 — the border quiets, the label carries the accent),
                        hover strengthens to the accent border over the tint. */}
                    <Button
                      variant="secondary"
                      className="tw-mb-6"
                      data-testid="rule-add-edit-manage-btn"
                      name="Add Condition"
                      onClick={() =>
                        ruleDispatch({ type: "ADD_CONDITIONAL" })
                      }
                    >
                      Add condition
                    </Button>
                  </div>
                </>
              )}
            {ruleType === CBM_RULE &&
              selectedCategories.leftCategory.id &&
              selectedCategories.rightCategory.id &&
              leftCatListOption &&
              rightCatListOption &&
              ((leftCatListOption === "values" &&
                leftCatAttributeSet.length > 0 &&
                leftValuesAttr) ||
                leftCatListOption === "products") &&
              ((rightCatListOption === "values" &&
                rightCatAttributeSet.length > 0 &&
                rightValuesAttr) ||
                rightCatListOption === "products") ? (
              <div className="cbm-rule-builder">
                <MatrixComponent />
              </div>
            ) : null}
          </div>
        </>
      )}
    </div>
  );

  const innerContent = (
    <>
      {isViewMode ? ruleHeaderEl : null}
      <div
        style={
          isViewMode
            ? { pointerEvents: "none", opacity: 0.6, userSelect: "none" }
            : {}
        }
      >
        {((ruleDetails && editPage) || !editPage) && !isViewMode ? ruleHeaderEl : null}
        {formContent}
      </div>
    </>
  );

  if (fromCategoryRelevancy) {
    return (
      <>
        {/* Backdrop */}
        <div data-testid="rules-add-edit-backdrop"
          className="tw-fixed tw-inset-0 tw-z-40"
          onClick={onClose}
          aria-hidden="true"
        />
        {/* Panel */}
        <div
          className="tw-fixed tw-right-0 tw-top-[60px] tw-bottom-0 tw-bg-surface tw-shadow-[0_4px_24px_rgba(0,0,0,0.18)] tw-z-50 tw-flex tw-flex-col"
          style={{ width: 'calc(100vw - 220px)' }}
        >
          <div className="tw-flex-1 tw-overflow-y-auto tw-px-6 tw-py-4">
            {innerContent}
          </div>
        </div>
      </>
    );
  }

  return innerContent;
}

export default RulesAddEditManage;
